import { useTimeout } from '@fuse/hooks';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useState } from 'react';
import clsx from 'clsx';
import Box from '@mui/material/Box';

interface Props {
  delay: number;
  showHeader?: boolean;
}

function FuseLoading(props: Props) {
  const [showLoading, setShowLoading] = useState(true);

  useTimeout(() => {
    setShowLoading(false);
  }, props.delay);

  return (
    <div
      className={clsx('flex flex-1 flex-col items-center justify-center', !showLoading && 'hidden')}
    >
      {props.showHeader === false ? null : (
        <Typography className='text-13 sm:text-20 font-medium' color='text.secondary'>
          Loading
        </Typography>
      )}
      <Box
        id='spinner'
        sx={{
          '& > div': {
            backgroundColor: 'palette.secondary.main',
          },
        }}
      >
        <div className='bounce1' />
        <div className='bounce2' />
        <div className='bounce3' />
      </Box>
    </div>
  );
}

FuseLoading.propTypes = {
  delay: PropTypes.number,
};

FuseLoading.defaultProps = {
  delay: 0,
};

export default FuseLoading;
